<template>
  <div class="loading-box">
    <div>Waiting for Twitter...</div>
    <loading-bar></loading-bar>
  </div>
</template>

<style scoped>
 .loading-box{
    color: gray;
    width: 100%;
    padding-top: 100px;
    text-align: center;
    font-size: 13pt;
  }
</style>

<script>
import UserApi from '@/api/UserApi'
import LoadingBar from '@/components/LoadingBar'
export default {
  name: 'WaitAuthResult',
  components: {LoadingBar},
  mounted () {
    UserApi.getToken().then(() => {
      const dest = decodeURIComponent((document.location.search || '?').substr(1)) || 'myimgs'
      const destFixed = dest.replace(/=null$/, '')
      this.$router.push(destFixed)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/WaitAuthResult.vue